<svelte:options customElement="hb-dashboard-card1" />

<script lang="ts">
  /**
   * Svelte Dashboard Card 1 WebComponent
   * =====================
   *
   * @contributors: Dario Caruso <dev@dariocaruso.info> (https://dariocaruso.info)
   *
   * @license: MIT License
   *
   */

  import type { Component } from "./types/webcomponent.type";

  let {
    id = "",
    // style,
    body = { noborder: false },
    header,
  }: Component = $props();

  function dispatch(name: string, detail: any) {
    $host().dispatchEvent(new CustomEvent(name, { detail }));
  }

  $effect(() => {
    if (typeof header === "string") {
      header = JSON.parse(header);
    }
    // if (!placeholder) {
    // 	placeholder = null;
    // } else if (typeof placeholder === "string") {
    // 	placeholder = JSON.parse(placeholder);
    // }
    if (typeof body === "string") {
      body = JSON.parse(body);
    }
    if (body && !body?.noborder) {
      body.noborder = false;
    }
  });
</script>

<svelte:head>
  <link
    rel="stylesheet"
    href="https://cdn.jsdelivr.net/npm/bootstrap-icons@latest/font/bootstrap-icons.css"
  />
</svelte:head>

<div part="card" class="card">
  <div class="card-header">
    <slot name="header_content">
      {#if header?.label}
        {#if header.icon}
          <i class="bi bi-{header.icon}"></i>
        {/if}
        <span>{header.label}</span>
      {/if}
      {#if header?.badge}
        <span style="float:right;margin-right:10px" class="badge bg-secondary"
          >{header.badge}</span
        >
      {/if}
    </slot>
  </div>
  <div class="card-body" style={body?.noborder ? "padding:0px" : ""}>
    <slot name="content">
      <!-- {#if placeholder?.type}
				{#if placeholder.type === "text" && placeholder.content}
					<div part="text_placeholder" id="text_placeholder">
						{placeholder.content}
					</div>
				{:else}
					todo
				{/if}
			{/if} -->
    </slot>
  </div>
  <!-- <div class="card-footer text-muted"><slot name="footer_content" /></div> -->
</div>

<style lang="scss">
  @forward "./styles/bootstrap.scss";
  @forward "./styles/webcomponent.scss";
</style>
